import { dashedToCamelCase } from '../../utils/convert-case';
import getCircleBracketsContent from '../../utils/get-circle-brackets-content';

const getColorNameByVariable = (variable) => dashedToCamelCase(getCircleBracketsContent(variable));

export default getColorNameByVariable;
